<ng-container *ngTemplateOutlet="hasPrice && smallDV ? smallDvPriceVariant : defaultVariant" />
<ng-template #infoPageButton>
  <div class="section">
    <button class="bricks-button button-fn" (click)="openInfoPage()">
      <span class="button-text">Informationen zur Direktvermarktung</span>
    </button>
  </div>
</ng-template>

<ng-template #defaultVariant>
  <bricks-card [isOutline]="true" class="process-card" id="success-default-variant">
    <section class="section">
      <img src="assets/images/success-ill.svg" alt="Anfrage erhalten" />
    </section>
    <section class="section">
      <div class="content">
        <div class="header-text">Vielen Dank!</div>
        <div class="text">
          Wir haben Ihre Anfrage erhalten und prüfen nun Ihre Angaben. <br />Anschließend erstellen wir ein
          individuelles Angebot, das Sie per E-Mail erhalten.
        </div>
        <div class="highlighted-text">Ihre Anfragenummer: {{ requestId() }}</div>
        <div class="text">
          Bitte geben Sie die Anfragenummer an, wenn Sie sich mit uns in Verbindung setzen. <br />Für Rückfragen
          erreichen Sie uns unter <a href="mailto:{{ contactEmail }}" target="_blank">{{ contactEmail }}</a
          >.
        </div>
      </div>
    </section>
    <section class="section">
      <ng-container *ngTemplateOutlet="infoPageButton" />
    </section>
  </bricks-card>
</ng-template>

<ng-template #smallDvPriceVariant>
  <bricks-card [isOutline]="true" class="process-card">
    <div id="success-smallDV-price-variant">
      <div class="price-variant-header">
        <div class="price-variant-text">
          <h2 class="header-text-left">
            Ihre Anfrage {{ requestId() }}<br />
            wurde ins EnBW VK Portal übertragen!
          </h2>
          <p>
            Sie erhalten in Kürze eine E-Mail an {{ partnerEmail }} mit einem Einladungslink zum Portal. Sollten Sie
            keine E-Mail erhalten haben, überprüfen Sie bitte den Spam-Ordner.
          </p>
          <p>
            Bitte geben Sie die Anfragenummer an, wenn Sie sich mit uns in Verbindung setzen.<br />Für Rückfragen
            erreichen Sie uns unter <a href="mailto:{{ contactEmail }}" target="_blank">{{ contactEmail }}</a>
          </p>
        </div>
        <div><img src="assets/images/price-success.svg" alt="Anfrage übertragen" /></div>
      </div>
      <div class="next-steps"><span>Nächste Schritte</span></div>
      <div class="success-steps" aria-label="Nächste Schritte">
        @for (stepLabel of smallDvPriceVariantSteps; track stepLabel; let i = $index) {
          <div class="success-step">
            <div class="success-step-head">
              <span class="success-step-index">{{ i + 1 }}</span>
              <span class="success-step-connector"></span>
            </div>
            <div class="success-step-label">{{ stepLabel }}</div>
          </div>
        }
      </div>
    </div>

    <ng-container *ngTemplateOutlet="infoPageButton" />
  </bricks-card>
</ng-template>
